module.exports = __webpack_public_path__ + "static/GorditaLight-Italic-38a7003f398e0610c751cd5d3b866675.woff2";